<template>
  <div class="h-full w-full">
    <canvas ref="canvasEl" class="h-full w-full"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  props: {
    labels: { type: Array, required: true },
    values: { type: Array, required: true },
    values2: { type: Array, required: false },
    color: { type: String, default: "#12b8c9" }
    ,
    color2: { type: String, default: "#1d4ed8" }
  },

  data() {
    return {
      chart: null
    };
  },

  mounted() {
    this.create();
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  watch: {
    labels() {
      this.renderOrUpdate();
    },
    values() {
      this.renderOrUpdate();
    },
    color() {
      this.renderOrUpdate();
    }
  },

  methods: {
    validateColor(color) {
      if (!color || typeof color !== "string") {
        return "#12b8c9";
      }
      const normalized = color.replace("#", "");
      const isValid = /^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/.test(normalized);
      return isValid ? color : "#12b8c9";
    },

    create() {
      if (!this.$refs.canvasEl) return;

      const validColor = this.validateColor(this.color);

      this.chart = new Chart(this.$refs.canvasEl, {
        type: "bar",

        data: {
          labels: this.labels,
          datasets: (function() {
            const ds = [
              {
                data: this.values,
                backgroundColor: validColor,
                borderRadius: 7,
                borderSkipped: false,
                barPercentage: 0.68,
                categoryPercentage: 0.72,
                maxBarThickness: 72
              }
            ];

            if (Array.isArray(this.values2)) {
              const validColor2 = this.validateColor(this.color2);
              ds.push({
                data: this.values2,
                backgroundColor: validColor2,
                borderRadius: 7,
                borderSkipped: false,
                barPercentage: 0.68,
                categoryPercentage: 0.72,
                maxBarThickness: 72
              });
            }

            return ds;
          }).call(this)
        },

        options: {
          responsive: true,
          maintainAspectRatio: false,

          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              backgroundColor: "#ffffff",
              titleColor: "#1e293b",
              bodyColor: "#475569",
              borderColor: "#e5e7eb",
              borderWidth: 1,
              padding: 10,
              displayColors: false
            }
          },

          scales: {
            x: {
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                color: "#6b7280",
                font: {
                  size: 11,
                  weight: "600"
                }
              }
            },

            y: {
              beginAtZero: true,
              grid: {
                color: "#e5e7eb",
                drawBorder: false
              },
              ticks: {
                color: "#6b7280",
                font: {
                  size: 11
                },
                stepSize: 2
              }
            }
          }
        }
      });
    },

    renderOrUpdate() {
      if (this.chart) {
        const validColor = this.validateColor(this.color);
        this.chart.data.labels = this.labels;
        if (this.chart.data.datasets[0]) {
          this.chart.data.datasets[0].data = this.values;
          this.chart.data.datasets[0].backgroundColor = validColor;
        }

        if (Array.isArray(this.values2)) {
          const validColor2 = this.validateColor(this.color2);
          if (this.chart.data.datasets[1]) {
            this.chart.data.datasets[1].data = this.values2;
            this.chart.data.datasets[1].backgroundColor = validColor2;
          } else {
            this.chart.data.datasets.push({
              data: this.values2,
              backgroundColor: validColor2,
              borderRadius: 7,
              borderSkipped: false,
              barPercentage: 0.68,
              categoryPercentage: 0.72,
              maxBarThickness: 72
            });
          }
        } else if (this.chart.data.datasets[1]) {
          // remove second dataset if it exists but no values2 provided
          this.chart.data.datasets.splice(1, 1);
        }

        this.chart.update();
        return;
      }

      this.create();
    }
  }
};
</script>

<style scoped></style>
